export default [
  'Full-time work',
  'Part-time work',
  'Volunteering',
  'Internship',
  'Fellowship',
  'Vacation work',
  'University Involvement'
]
